/* TheNextBaby theme JS: cart drawer (Cart AJAX + Section Rendering API), add buttons, wishlist,
   predictive search, countdowns, email popup, product form. Vanilla, deferred, delegation-based. */
(function () {
  if (window.TNB) return;
  var cfg = window.TNB_CFG || {};
  var DRAWER = 'tnb-cart-drawer';
  var root = document.documentElement;
  var money = function (cents) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cfg.currency || 'USD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };

  /* ---------------- cart drawer ---------------- */
  var lastFocus = null;
  function drawerEl() { return document.querySelector('[data-tb-drawer]'); }
  function openCart() {
    lastFocus = document.activeElement;
    root.classList.add('tb-cart-open');
    var p = document.querySelector('.tb-drawer__panel'); if (p) setTimeout(function () { p.focus(); }, 30);
  }
  function closeCart() {
    root.classList.remove('tb-cart-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function renderDrawer(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-tb-drawer]'), cur = drawerEl();
    if (fresh && cur) {
      var sc = cur.querySelector('.tb-drawer__scroll'), top = sc ? sc.scrollTop : 0;
      cur.innerHTML = fresh.innerHTML;
      var sc2 = cur.querySelector('.tb-drawer__scroll'); if (sc2) sc2.scrollTop = top;
    }
  }
  function setCount(n) { document.querySelectorAll('[data-tb-cart-count]').forEach(function (e) { e.textContent = n; }); }
  function refreshCount() { return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); return c; }); }
  function sectionsUrl() { return window.location.pathname; }

  function addItems(items, opts) {
    opts = opts || {};
    return fetch((window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: DRAWER, sections_url: sectionsUrl() })
    }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Could not add to cart'); return d; }); })
      .then(function (d) {
        if (d.sections) renderDrawer(d.sections[DRAWER]);
        refreshCount();
        document.dispatchEvent(new CustomEvent('tnb:cart-updated'));
        if (!opts.stay && cfg.openOnAdd !== false) openCart();
        return d;
      });
  }
  function changeLine(key, qty) {
    var d = drawerEl(); if (d) d.classList.add('is-busy');
    return fetch((window.routes && routes.cart_change_url ? routes.cart_change_url : '/cart/change') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: DRAWER, sections_url: sectionsUrl() })
    }).then(function (r) { return r.json(); }).then(function (c) {
      if (c.sections) renderDrawer(c.sections[DRAWER]);
      setCount(c.item_count);
      document.dispatchEvent(new CustomEvent('tnb:cart-updated'));
    }).finally(function () { var d2 = drawerEl(); if (d2) d2.classList.remove('is-busy'); });
  }
  function setGiftWrap(on) {
    return fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { gift_wrap: on ? 'Yes' : '' }, sections: DRAWER, sections_url: sectionsUrl() })
    }).then(function (r) { return r.json(); }).then(function (c) { if (c.sections) renderDrawer(c.sections[DRAWER]); });
  }
  function flashAdded(btn, ok, msg) {
    btn.dataset.label = btn.dataset.label || btn.textContent;
    if (ok) { btn.classList.add('tb-pill--added'); btn.textContent = 'Added ✓'; }
    else { btn.textContent = msg || 'Try again'; }
    setTimeout(function () { btn.classList.remove('tb-pill--added'); btn.textContent = btn.dataset.label; btn.disabled = false; }, ok ? 900 : 2200);
  }

  document.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-tb-cart-open]'))) { e.preventDefault(); openCart(); return; }
    if ((t = e.target.closest('[data-tb-cart-close]'))) { e.preventDefault(); closeCart(); return; }
    if ((t = e.target.closest('[data-tb-add]'))) {
      e.preventDefault(); if (t.disabled) return; t.disabled = true;
      var stay = t.hasAttribute('data-tb-stay');
      addItems([{ id: +t.dataset.tbAdd, quantity: +(t.dataset.qty || 1) }], { stay: true })
        .then(function () { flashAdded(t, true); if (!stay && cfg.openOnAdd !== false) setTimeout(openCart, 450); })
        .catch(function (err) { flashAdded(t, false, err.message && err.message.length < 40 ? err.message : 'Try again'); });
      return;
    }
    if ((t = e.target.closest('[data-tb-qty]'))) { e.preventDefault(); changeLine(t.dataset.tbQty, +t.dataset.q); return; }
    if ((t = e.target.closest('[data-tb-wish]'))) { e.preventDefault(); toggleWish(t.dataset.tbWish); return; }
    if ((t = e.target.closest('[data-tb-popup-close]'))) { e.preventDefault(); closePopup(); return; }
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-tb-gift-wrap]')) setGiftWrap(e.target.checked);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { if (root.classList.contains('tb-cart-open')) closeCart(); closePopup(); }
  });

  /* ---------------- wishlist (localStorage) ---------------- */
  var WK = 'tnb-wishlist';
  function getWish() { try { return JSON.parse(localStorage.getItem(WK)) || []; } catch (e) { return []; } }
  function setWish(a) { try { localStorage.setItem(WK, JSON.stringify(a.slice(0, 60))); } catch (e) {} paintWish(); }
  function toggleWish(h) { var a = getWish(), i = a.indexOf(h); if (i > -1) a.splice(i, 1); else a.unshift(h); setWish(a); }
  function paintWish() {
    var a = getWish();
    document.querySelectorAll('[data-tb-wish]').forEach(function (b) { b.setAttribute('aria-pressed', a.indexOf(b.dataset.tbWish) > -1 ? 'true' : 'false'); });
    document.querySelectorAll('[data-tb-wish-count]').forEach(function (c) { c.textContent = a.length; });
  }

  /* ---------------- predictive search ---------------- */
  function initSearch() {
    document.querySelectorAll('[data-tb-search]').forEach(function (f) {
      if (f.__tb) return; f.__tb = 1;
      var inp = f.querySelector('input[name=q]'), res = f.querySelector('[data-tb-search-res]'), t;
      inp.addEventListener('input', function () {
        clearTimeout(t); var q = inp.value.trim();
        if (q.length < 2) { res.hidden = true; return; }
        t = setTimeout(function () {
          fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last')
            .then(function (r) { return r.json(); }).then(function (d) {
              var R = d.resources.results, h = '';
              (R.collections || []).slice(0, 3).forEach(function (c) { h += '<a href="' + c.url + '"><span style="font-size:12px;color:#5B6680">Category</span> ' + esc(c.title) + '</a>'; });
              (R.products || []).forEach(function (p) { h += '<a href="' + p.url + '">' + (p.image ? '<img src="' + p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=88" alt="">' : '') + '<span>' + esc(p.title) + '</span><b>' + money(Math.round(parseFloat(p.price) * 100)) + '</b></a>'; });
              res.innerHTML = h || '<p style="margin:8px 10px;color:#5B6680">No matches. Press Enter to search everything.</p>';
              res.hidden = false;
            });
        }, 180);
      });
      document.addEventListener('click', function (e) { if (!f.contains(e.target)) res.hidden = true; });
    });
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------------- countdowns (real end dates only) ---------------- */
  function parseEnd(s) { if (!s) return NaN; var d = new Date(String(s).trim().replace(' ', 'T')); return d.getTime(); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tickCountdowns() {
    var now = Date.now();
    document.querySelectorAll('[data-tb-countdown]').forEach(function (el) {
      var end = el.__end || (el.__end = parseEnd(el.dataset.tbCountdown));
      if (isNaN(end)) return;
      var s = Math.max(0, Math.floor((end - now) / 1000));
      var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), x = s % 60;
      var dd = Math.floor(h / 24); el.textContent = (dd > 0 ? dd + 'd ' + pad(h % 24) : pad(h)) + ':' + pad(m) + ':' + pad(x);
      if (s === 0) { var w = el.closest('[data-tb-countdown-wrap]'); if (w && !w.hasAttribute('data-tb-preview')) w.hidden = true; }
    });
    /* same-day sending: before the cutoff on a weekday = sent today, otherwise the next business day */
    var hr = +((document.querySelector('[data-tb-send]') || {}).dataset || {}).tbSend || 14;
    var now = new Date(), cut = new Date(); cut.setHours(hr, 0, 0, 0);
    var wd = now.getDay(), today = wd > 0 && wd < 6 && now < cut;
    var nxt = new Date(now); do { nxt.setDate(nxt.getDate() + 1); } while (nxt.getDay() === 0 || nxt.getDay() === 6);
    var tmw = new Date(now); tmw.setDate(tmw.getDate() + 1);
    var dayName = nxt.toDateString() === tmw.toDateString() ? 'tomorrow' : nxt.toLocaleDateString('en-US', { weekday: 'long' });
    document.querySelectorAll('[data-tb-sendday]').forEach(function (el) {
      var full = el.closest('[data-tb-send]');
      el.textContent = 'Ships ' + (today ? 'Today' : dayName.charAt(0).toUpperCase() + dayName.slice(1));
    });
    document.querySelectorAll('[data-tb-sendnote]').forEach(function (el) { el.hidden = !today; });
    document.querySelectorAll('[data-tb-cutoff]').forEach(function (el) {
      var s = Math.max(0, Math.floor((cut - now) / 1000)); el.textContent = Math.floor(s / 3600) + 'h ' + pad(Math.floor((s % 3600) / 60)) + 'm';
    });
  }

  /* ---------------- email popup ---------------- */
  var PK = 'tnb-popup-done';
  function closePopup() { var p = document.querySelector('[data-tb-popup]'); if (!p || p.hidden) return; p.hidden = true; try { localStorage.setItem(PK, '1'); } catch (e) {} }
  function initPopup() {
    var p = document.querySelector('[data-tb-popup]'); if (!p) return;
    var done = false; try { done = localStorage.getItem(PK) === '1'; } catch (e) {}
    if (p.hasAttribute('data-tb-popup-posted')) { p.hidden = false; try { localStorage.setItem(PK, '1'); } catch (e) {} return; }
    if (done) return;
    setTimeout(function () { if (!root.classList.contains('tb-cart-open') && !/\/checkout/.test(location.pathname)) { p.hidden = false; var i = p.querySelector('input[type=email]'); if (i) i.focus(); } }, (+p.dataset.delay || 8) * 1000);
  }

  /* ---------------- product form ---------------- */
  function initProduct(scope) {
    (scope || document).querySelectorAll('[data-tb-pdp]').forEach(function (w) {
      if (w.__tb) return; w.__tb = 1;
      var data = {}; try { data = JSON.parse(w.querySelector('[data-tb-pdp-json]').textContent); } catch (e) { return; }
      var variants = data.variants || [], form = w.querySelector('form[data-tb-pdp-form]'), idIn = form.querySelector('[name=id]');
      var qtyIn = form.querySelector('[name=quantity]'), btn = w.querySelector('[data-tb-pdp-add]'), priceEl = w.querySelector('[data-tb-pdp-price]');
      var wasEl = w.querySelector('[data-tb-pdp-was]'), saveEl = w.querySelector('[data-tb-pdp-save]'), q4 = w.querySelector('[data-tb-pdp-q4]');
      var sticky = document.querySelector('[data-tb-sticky]');
      function selected() {
        var vals = [];
        w.querySelectorAll('[data-tb-opt]').forEach(function (g) { var c = g.querySelector('input:checked'); vals[+g.dataset.tbOpt] = c ? c.value : null; });
        return variants.find(function (v) { return v.options.every(function (o, i) { return vals[i] == null || o === vals[i]; }); });
      }
      function qty() { return Math.max(1, parseInt(qtyIn.value, 10) || 1); }
      function tierPct(n) { if (!data.multibuy) return 0; return n >= 3 ? 10 : n === 2 ? 5 : 0; }
      function paint() {
        var v = selected(), n = qty();
        if (v) {
          idIn.value = v.id;
          if (priceEl) priceEl.textContent = money(v.price);
          if (wasEl) { wasEl.hidden = !(v.compare_at_price > v.price); wasEl.textContent = money(v.compare_at_price || 0); }
          if (saveEl) { saveEl.hidden = !(v.compare_at_price > v.price); saveEl.textContent = 'Save ' + money((v.compare_at_price || 0) - v.price); }
          if (q4) q4.textContent = money(Math.ceil(v.price / 4));
          w.querySelectorAll('[data-tb-each]').forEach(function (e) { var p = +e.dataset.tbEach; e.textContent = money(Math.round(v.price * (100 - p) / 100)) + ' each'; });
          if (v.img) {
            var main = w.querySelector('[data-tb-main] img'), vt = w.querySelector('[data-tb-vthumb]');
            if (main && main.dataset.cur !== v.img) { main.removeAttribute('srcset'); main.src = v.img; main.dataset.cur = v.img; }
            if (vt) { vt.dataset.big = v.img; vt.dataset.tbMedia = v.featured_media_id; var ti = vt.querySelector('img'); if (ti) { ti.removeAttribute('srcset'); ti.src = v.thumb; } }
            w.querySelectorAll('[data-tb-media]').forEach(function (x) { x.setAttribute('aria-current', x === vt ? 'true' : 'false'); });
          }
          var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
        }
        var sub = v ? v.price * n : 0; var total = sub - Math.floor(sub * tierPct(n) / 100);
        var ok = v && v.available;
        btn.disabled = !ok;
        btn.textContent = !v ? 'Unavailable' : (!v.available ? 'Sold out' : 'Add to cart · ' + money(total));
        w.querySelectorAll('[data-tb-tier]').forEach(function (b) { var t = +b.dataset.tbTier; b.setAttribute('aria-pressed', (t === 3 ? n >= 3 : n === t) ? 'true' : 'false'); });
        w.querySelectorAll('[data-tb-optval]').forEach(function (l) { var g = l.closest('[data-tb-opt]'); l.classList.toggle('is-on', l.querySelector('input').checked); });
        w.querySelectorAll('[data-tb-opt]').forEach(function (g) { var c = g.querySelector('input:checked'), n = g.querySelector('[data-tb-optname]'); if (c && n) n.textContent = c.value; });
        if (sticky) {
          var sb = sticky.querySelector('[data-tb-sticky-price]'); if (sb && v) sb.textContent = money(v.price);
          var sbb = sticky.querySelector('[data-tb-sticky-add]'); if (sbb) { sbb.disabled = !ok; sbb.textContent = ok ? 'Add to cart' : 'Sold out'; }
        }
      }
      w.addEventListener('change', function (e) { if (e.target.closest('[data-tb-opt]')) paint(); });
      w.addEventListener('click', function (e) {
        var t;
        if ((t = e.target.closest('[data-tb-step]'))) { e.preventDefault(); qtyIn.value = Math.max(1, qty() + (+t.dataset.tbStep)); paint(); }
        if ((t = e.target.closest('[data-tb-tier]'))) { e.preventDefault(); qtyIn.value = t.dataset.tbTier; paint(); }
        if ((t = e.target.closest('[data-tb-media]'))) {
          e.preventDefault();
          var main = w.querySelector('[data-tb-main]'), img = t.querySelector('img');
          w.querySelectorAll('[data-tb-media]').forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
          if (main && img) { var big = t.dataset.big, mi = main.querySelector('img'); mi.removeAttribute('srcset'); mi.src = big; mi.alt = img.alt; mi.dataset.cur = big; }
        }
      });
      qtyIn.addEventListener('change', paint);
      form.addEventListener('submit', function (e) {
        e.preventDefault(); if (btn.disabled) return; btn.disabled = true;
        var props = {}; var gift = form.querySelector('[data-tb-gift]'); if (gift && gift.checked) props['Gift'] = 'Wrap & card, hide prices';
        var item = { id: +idIn.value, quantity: qty() }; if (Object.keys(props).length) item.properties = props;
        var items = [item]; form.querySelectorAll('[data-tb-addon]:checked').forEach(function (c) { items.push({ id: +c.value, quantity: 1 }); });
        addItems(items, { stay: true }).then(function () { form.querySelectorAll('[data-tb-addon]:checked').forEach(function (c) { c.checked = false; }); flashAdded(btn, true); setTimeout(function () { paint(); openCart(); }, 450); })
          .catch(function (err) { flashAdded(btn, false, err.message && err.message.length < 60 ? err.message : 'Try again'); setTimeout(paint, 2300); });
      });
      if (sticky) {
        var addSticky = sticky.querySelector('[data-tb-sticky-add]');
        if (addSticky) addSticky.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })); });
        var io = new IntersectionObserver(function (en) { sticky.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); root.classList.toggle('tb-sticky-on', sticky.classList.contains('is-on')); });
        io.observe(btn);
      }
      paint();
    });
  }

  /* ---------------- init ---------------- */
  function init() { paintWish(); initSearch(); tickCountdowns(); initProduct(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  setInterval(tickCountdowns, 1000);
  window.addEventListener('load', initPopup);
  document.addEventListener('shopify:section:load', function (e) { paintWish(); initSearch(); initProduct(e.target); });
  window.TNB = { addItems: addItems, openCart: openCart, closeCart: closeCart };
})();

/* ---------------- product gallery: swipe left/right on the main image (mobile) ---------------- */
(function () {
  var m = document.querySelector('[data-tb-main]'); if (!m) return;
  var x0 = null, y0 = 0;
  m.style.touchAction = 'pan-y';
  m.addEventListener('touchstart', function (e) { var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; }, { passive: true });
  m.addEventListener('touchend', function (e) {
    if (x0 === null) return;
    var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0; x0 = null;
    if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
    var th = [].slice.call(document.querySelectorAll('[data-tb-pdp] [data-tb-media]')); if (th.length < 2) return;
    var i = 0; th.forEach(function (b, k) { if (b.getAttribute('aria-current') === 'true') i = k; });
    th[(i + (dx < 0 ? 1 : -1) + th.length) % th.length].click();
  }, { passive: true });
})();
